module.exports = __webpack_public_path__ + "img/winS2-bg-cn-m.327ef2de.jpg";